import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import draggable from "vuedraggable";
import MaterialInput from "@Shared/components/inputs/material-input";
import { pick } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReadOnlyArgument",
  components: {
    Fragment,
    draggable,
    MaterialInput
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    checklist: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    editTitle: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      default: ""
    },
    isEditor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var _context;
    return {
      modelItems: _mapInstanceProperty(_context = this.checklist).call(_context, (item, index) => _objectSpread(_objectSpread({}, item), {}, {
        editing: false,
        order: index
      })),
      newItem: "",
      nonce: 0,
      checklistTitle: this.title,
      labelValue: uuidv4()
    };
  },
  computed: {
    percentCompleted() {
      var _context2;
      const totalItems = this.modelItems.length;
      if (totalItems === 0) return 0;
      const completed = _filterInstanceProperty(_context2 = this.modelItems).call(_context2, item => item.completed).length;
      return Math.round(completed * 100 / totalItems);
    }
  },
  watch: {
    checklist() {
      var _context3;
      this.modelItems = _mapInstanceProperty(_context3 = this.checklist).call(_context3, (item, index) => _objectSpread(_objectSpread({}, item), {}, {
        editing: false,
        order: index
      }));
    },
    title() {
      this.checklistTitle = this.title;
    },
    checklistTitle() {
      this.handleChange();
    }
  },
  methods: {
    toggle(index) {
      if (this.readOnly) return;
      this.modelItems[index].completed = !this.modelItems[index].completed;
      this.handleChange();
    },
    remove(index) {
      var _context4;
      if (this.readOnly) return;
      _spliceInstanceProperty(_context4 = this.modelItems).call(_context4, index, 1);
      this.modelItems = [...this.modelItems];
      this.handleChange();
    },
    edit(index) {
      if (this.readOnly) return;
      this.modelItems[index].editing = true;
      this.$refs[`item-${index}`][0].contentEditable = true;
      this.setCursorToItem(index);
    },
    stopEdit(index) {
      var _context5;
      const item = $(this.$refs[`item-${index}`]);
      const newText = _trimInstanceProperty(_context5 = item.text()).call(_context5);
      if (newText === "") return;
      this.modelItems[index].editing = false;
      this.modelItems[index].text = newText;
      this.$refs[`item-${index}`][0].removeAttribute("contenteditable");
      this.handleChange();
    },
    addItem() {
      var _context6;
      const newItem = _trimInstanceProperty(_context6 = this.newItem).call(_context6);
      if (newItem !== "") {
        this.modelItems.push({
          text: newItem,
          completed: false,
          editing: false,
          order: this.modelItems.length
        });
        this.newItem = "";
        this.handleChange();
      }
    },
    setCursorToItem(index) {
      const item = $(this.$refs[`item-${index}`]);
      item.focus();
      const hasSelection = typeof window.getSelection != "undefined" && typeof document.createRange != "undefined";
      const supportsTextRange = typeof document.body.createTextRange != "undefined";

      //Put cursor at end
      if (hasSelection) {
        const range = document.createRange();
        const sel = window.getSelection();
        range.selectNodeContents(item[0]);
        range.collapse(false);
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (supportsTextRange) {
        const textRange = document.body.createTextRange();
        textRange.moveToElementText(item[0]);
        textRange.collapse(false);
        textRange.select();
      }
    },
    handleChange() {
      var _context7;
      this.$emit("input", {
        title: this.checklistTitle,
        checklist: _mapInstanceProperty(_context7 = this.modelItems).call(_context7, item => {
          return pick(item, ["text", "completed"]);
        })
      });
      this.nonce++;
    }
  }
});